module.exports = __webpack_public_path__ + "img/plattenverlegung.9d3aa7f2.svg";